import { render, staticRenderFns } from "./SectionStatusModal.vue?vue&type=template&id=32ad0182"
import script from "./SectionStatusModal.vue?vue&type=script&lang=js"
export * from "./SectionStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports